import * as yup from 'yup';

export const validations = yup.object().shape({
  email: yup
    .string()
    .email('O e-mail precisa ser válido')
    .required('O e-mail é obrigatório')
});